import * as PANOLENS from "panolens";
console.log(PANOLENS);
const panorama = new PANOLENS.ImagePanorama("/assets/pano1.jpg");
console.log(panorama);
const viewer = new PANOLENS.Viewer({
  container: document.querySelector("#alex")
});
console.log(viewer);
viewer.add(panorama);
const Pano = () => {
  return (
    <>
      <p>Alexandria</p>
      <div id="Alexandria" htmlstyle="height:100%">
        {}
      </div>
    </>
  );
};

export default Pano;
